import type { MatchingEventViewDto } from '../../api/matchingTypes';
import type { RootState } from '../store';

export const selectMatchingEnabled = (s: RootState) => s.matching.enabled;
export const selectMatchingMeta =(s: RootState) => s.matching.meta;
export const selectMatchingBoard = (s: RootState) => s.matching.board;
export const selectMatchingPanelByDate = (s: RootState) => s.matching.panelByDate;

export const selectMatchingEventView =
  (eventId: string) =>
  (s: RootState): MatchingEventViewDto | undefined =>
    s.matching.eventViewsById[eventId];
